/*
 * @Author: dinglizu
 * @Date: 2022-12-30 10:19:49
 * @LastEditTime: 2023-03-01 16:52:08
 * @LastEditors: dinglizu
 * @Description: 
 */
import AudioPlayer   from '@/components/toefl/audio/components/player.vue'
import Recorder from "@/components/toefl/common/recorder";
const components = {
  AudioPlayer,
  Recorder,

  install (Vue) {
    if (this.installed) {
      return
    }

    this.installed = true

    Vue.prototype.$eventBus = Vue.prototype.$eventBus || new Vue

    Vue.component('audio-player', AudioPlayer)
    Vue.component('recorder', Recorder)
  }
}

export default components

export { AudioPlayer, Recorder }



// WEBPACK FOOTER //
// ./src/components/toefl/audio/index.js